/* app/js/src/components/content-control/operation-room/content-control-operation-room.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.cc-live-container {
  display: flex;
  overflow: auto;
}
.cc-live-container .cc-live-main {
  flex-grow: 1;
  height: 92vh;
  display: flex;
  flex-direction: column;
}
.cc-live-container .cc-live-main .select-container {
  flex: 0 0 5%;
  display: flex;
  align-items: center;
  padding: 10px;
}
.cc-live-container .cc-live-main .grid-container {
  flex: 1;
  align-self: center;
  display: grid;
  gap: 8px;
  row-gap: 8px;
  padding: 10px;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  height: 100%;
  align-items: stretch;
  justify-items: stretch;
}
.cc-live-container .cc-live-main .grid-container:has(> :nth-child(2):last-child) {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  max-width: none;
  height: 100%;
  justify-content: center;
}
.cc-live-container .cc-live-main .grid-container:has(> :nth-child(4):last-child) {
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
}
.cc-live-container .cc-live-main .grid-container > * {
  aspect-ratio: 16/9;
  width: 100%;
  height: max-content;
  object-fit: cover;
}
/*# sourceMappingURL=content-control-operation-room.component.css.map */
